var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoLocate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "geoLocateNeutral"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    strokeWidth: 2.75,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.75,
    d: "M16 0v8M32 16h-8M16 32v-8M0 16h8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "geoLocateDisabled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    "transform-origin": "16 16",
    transform: "rotate(-22.5)",
    strokeWidth: 2.75,
    d: "M4 16A12 12 0 0 1 24 7.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    "transform-origin": "16 16",
    transform: "rotate(-202.5)",
    strokeWidth: 2.75,
    d: "M4 16A12 12 0 0 1 24 7.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.75,
    d: "M16 0v8M32 16h-8M16 32v-8M0 16h8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.75,
    d: "M4 28L28 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoLocate);
export default __webpack_public_path__ + "static/media/geoLocate.9bf4d5dc5ae9d7e8464ab09c63c97a8e.svg";
export { ForwardRef as ReactComponent };